// @flow

import React from 'react';
import classNames from 'classnames';
import { Collapse } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import type { Props } from '.';
import './profile.scss';

const getProfileId = () => localStorage.getItem('profileId');

class Profile extends React.Component<Props> {
  constructor() {
    super();
    this.addedCollapseEvent = false;
    this.getActiveUser = this.getActiveUser.bind(this);
    this.handleOutsideMenuTouch = this.handleOutsideMenuTouch.bind(this);
  }

  getActiveUser() {
    const { user } = this.props;
    return (user &&
      user.profiles &&
      user.profiles.find(({ profileId }) => profileId === getProfileId())) || {};
  }

  handleOutsideMenuTouch() {
    const { closeProfileMenu } = this.props;
    closeProfileMenu();
  }

  renderProfileItems() {
    const { user, changeProfile } = this.props;
    return (
      <React.Fragment>
        {user.profiles.map(({ profileId, organisationProfile }) => {
          if (getProfileId() !== profileId) {
            return (
              <li className="nav-item profile-item" key={profileId}>
                <button
                  type="button"
                  onClick={() => {
                    changeProfile(profileId);
                  }}
                  className={classNames(
                    'd-flex flex-row align-items-center m-0',
                  )}
                >
                  <div className="prs-icon prs-icon-switch" />
                  <div>
                    <p className="normal-card mb-1">
                      {organisationProfile.organisation.organisationName}
                    </p>
                    <span className="membership-header">
                      Membership no.
                    </span>
                    <span className="membership-number">
                      <span>&nbsp;</span>
                      {organisationProfile.ipiNumber}
                      {organisationProfile.organisation.publisher}
                    </span>
                  </div>
                </button>
              </li>
            );
          }
          return null;
        })}
      </React.Fragment>
    );
  }

  renderNavitems() {
    return (
      <ul className="nav navbar-nav">
        {this.renderProfileItems()}
        <li className="nav-item profile-item profile-item--sign-out">
          <NavLink to="logout" className="d-flex flex-row align-items-center">
            <div className="prs-icon prs-icon-sign-out" />
            <div>
              <p className="normal-card mb-1">
                Sign Out
              </p>
            </div>
          </NavLink>
        </li>
      </ul>
    );
  }

  render() {
    const { showProfileMenu } = this.props;
    const { OrganisationProfile } = this.getActiveUser();
    const nameOfLoggedInUser = OrganisationProfile &&
      OrganisationProfile.organisation &&
      OrganisationProfile.organisation.organisationName;
    const caeNumber = OrganisationProfile && OrganisationProfile.ipiNumber;
    return (
      <Collapse className="profile-menu" id="profileContent" isOpen={showProfileMenu} navbar>
        <div className="user-profile">
          <h3>{nameOfLoggedInUser}</h3>
          <p className="m-0">
            <span className="membership-header">Membership no. </span>
            <span className="membership-cae">
              <span>&nbsp;</span>
              {caeNumber}
            </span>
          </p>
        </div>
        {this.renderNavitems()}
      </Collapse>
    );
  }
}

export default Profile;
